import { ACTION_TYPES } from '../../constants/store.constants';
import { ADO_LEFT, VDO_LEFT } from '../../constants/interpreter.constants';

const initialState = {
  type: null,
  language: null,
  serviceArea: null,
  searchQuery: '',
  serviceAreaIsLoading: false,
  interpreterLanguageList: null,
  displayList: [],
  suppressAutoSelect: false,
  disableServiceArea: null,
  disableLanguageList: null,
  videoJoinedInterpretersList: [],
  audioJoinedInterpretersList: []
};

const InterpreterReducer = (state, { type, payload } = {}) => {
  if (!state) state = initialState;
  switch (type) {
    case ACTION_TYPES.SET_INTERPRETER_TYPE:
      return {
        ...state,
        type: payload
      };
    case ACTION_TYPES.SET_INTERPRETER_LANGUAGE:
      return {
        ...state,
        language: payload
      };
    case ACTION_TYPES.SET_INTERPRETER_SERVICE_AREA:
      return {
        ...state,
        serviceArea: payload
      };
    case ACTION_TYPES.SET_INTERPRETER_SEARCH_QUERY:
      return {
        ...state,
        searchQuery: payload
      };
    case ACTION_TYPES.SET_SERVICE_AREA_IS_LOADING:
      return {
        ...state,
        serviceAreaIsLoading: payload
      };
    case ACTION_TYPES.SET_INTERPRETER_LANGUAGE_LIST:
      return {
        ...state,
        interpreterLanguageList: payload
      };
    case ACTION_TYPES.SET_INTERPRETER_DISPLAY_LIST:
      return {
        ...state,
        displayList: payload
      };
    case ACTION_TYPES.DISABLE_SERVICE_AREA:
      return {
        ...state,
        disableServiceArea: payload
      };
    case ACTION_TYPES.DISABLE_LANGUAGE_LIST:
      return {
        ...state,
        disableLanguageList: payload
      };
    case ACTION_TYPES.SET_VIDEO_JOINED_INTERPRETER_LIST: {
      // If payload contains VDO_LEFT, clear the list
      if (Array.isArray(payload) && payload.some(event => event.eventID === VDO_LEFT)) {
        return { ...state, videoJoinedInterpretersList: [] };
      }
      return { ...state, videoJoinedInterpretersList: payload };
    }
    case ACTION_TYPES.SET_AUDIO_JOINED_INTERPRETER_LIST: {
      // If payload contains ADO_LEFT, clear the list
      if (Array.isArray(payload) && payload.some(event => event.eventID === ADO_LEFT)) {
        return { ...state, audioJoinedInterpretersList: [] };
      }
      return { ...state, audioJoinedInterpretersList: payload };
    }
    default:
      return state;
  }
};

export default InterpreterReducer;
